import FloatingLabelInput from 'components/ui/FloatingLabelInput';
import Card from 'components/ui/Card';
import { Briefcase } from 'assets/icons/revamp';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateMoreOptionCategory } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const Category: React.FC = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);

  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-center ~gap-2/3'>
        <Briefcase
          className='~w-3/4 ~h-3/4 flex-shrink-0 text-primary-500 dark:text-primary-dark-500 ~mt-0.5/1'
          fill='currentColor'
          fillDarkMode='currentColor'
        />
        <h3 className='~text-xs/base font-semibold text-black dark:text-white'>
          {t('category')}
        </h3>
      </div>
      <FloatingLabelInput
        placeholder={t('category')}
        type='text'
        value={activity?.category ?? ''}
        onChange={(e) => dispatch(updateMoreOptionCategory(e.target.value))}
        size='small'
        showLabel
        label={t('category')}
      />
    </Card>
  );
};

export default Category;
